import React, { FC, useState, Fragment } from 'react';
import { Box, Avatar, AvatarSize, Text } from '@bechtel/gds';
import { Attachment, AttachmentType, MilestoneStatusCode } from '@bechtel/types';
import { map, filter } from 'lodash';
import { ImageViewer, useImageViewerState, useName, useDate, MilestoneStatusMessages } from '@bechtel/client-common';
import { ImageBoxStyled, ImageStyled } from '../styled';
import { useLingui } from '@lingui/react';
import { PersonaMessages } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';

interface ImageGalleryProps {
  attachments: Attachment[];
  milestoneStatus: MilestoneStatusCode;
}

export const WeldPhotoList: FC<ImageGalleryProps> = ({ attachments, milestoneStatus }) => {
  const [imagePosition, setImagePosition] = useState(0);
  const { open: openImageViewer, close: closeImageViewer, visible: visibleImageViewer } = useImageViewerState(false);
  const images = attachments && attachments.length > 0 ? map(attachments, (attachment) => attachment?.url) : [];
  const { getFullName } = useName();
  const { i18n } = useLingui();
  const { formatISODate } = useDate();

  const setGalleryImagePosition = (index) => {
    setImagePosition(index);
  };

  return (
    <Fragment>
      {visibleImageViewer && (
        <ImageViewer
          images={images}
          selectedImageIndex={imagePosition}
          visible={visibleImageViewer}
          closable={true}
          onDismiss={closeImageViewer}
        />
      )}
      <Box data-testid="weld-card-image" mb={{ sm: '500' }}>
        <Box
          data-testid="weld-image-viewer"
          style={{ flexFlow: 'row wrap' }}
          flexDirection={{ sm: 'column' }}
          flexGrow={{ sm: 1 }}
          justifyContent={{ sm: 'space-between' }}
        >
          {attachments &&
            attachments.length &&
            map(
              filter(attachments, (attachment) => attachment?.attachmentType == AttachmentType.IMAGE),
              (file, index: number) => {
                return (
                  <ImageBoxStyled key={file.id}>
                    <ImageStyled
                      src={file['url']}
                      onClick={(e) => {
                        setGalleryImagePosition(index);
                        e.stopPropagation();
                        openImageViewer();
                      }}
                    />
                    {file?.creator?.id && (
                      <Box justifyContent={{ sm: 'space-between' }} alignItems={{ sm: 'center' }} p={{ sm: '400' }}>
                        <Box>
                          <Avatar
                            size={AvatarSize.MEDIUM}
                            src={file?.creator?.imageUrl ? file.creator.imageUrl : undefined}
                          />
                          <Box flexDirection={{ sm: 'column' }} ml={{ sm: '400' }}>
                            <Box mb={{ sm: '300' }}>
                              <Text size="300" color="grey.1000" weight="600" family="graphikCompact">
                                {getFullName(file?.creator?.firstName, file?.creator?.lastName)}
                              </Text>
                            </Box>
                            <Text size="300" color="grey.1000" family="graphikCompact">
                              {i18n._(PersonaMessages[file?.creator?.persona])}
                            </Text>
                          </Box>
                        </Box>
                        <Box flexDirection={{ sm: 'column' }} alignItems={{ sm: 'flex-end' }}>
                          <Box mb={{ sm: '300' }}>
                            <Text size="300" color="grey.1000" family="graphikCompact">
                              {formatISODate(file?.createdAt)}
                            </Text>
                          </Box>
                          <Text size="300" color="grey.1000" family="graphikCompact">
                            <Trans>Status</Trans>: {milestoneStatus && i18n._(MilestoneStatusMessages[milestoneStatus])}
                          </Text>
                        </Box>
                      </Box>
                    )}
                  </ImageBoxStyled>
                );
              }
            )}
        </Box>
      </Box>
    </Fragment>
  );
};
